'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var dagPB = require('ipld-dag-pb');

var DAGLink = dagPB.DAGLink;

var CID = require('cids');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

function findLinks(node) {
  var links = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var key in node) {
    var val = node[key];

    if (key === '/' && Object.keys(node).length === 1) {
      try {
        links.push(new DAGLink('', 0, new CID(val)));
        continue;
      } catch (_) {// not a CID
      }
    }

    if (CID.isCID(val)) {
      links.push(new DAGLink('', 0, val));
      continue;
    }

    if (Array.isArray(val)) {
      findLinks(val, links);
    }

    if (val && typeof val === 'object') {
      findLinks(val, links);
    }
  }

  return links;
}

module.exports = function (_ref) {
  var dag = _ref.dag;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _links = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(multihash, options) {
      var cid, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              cid = new CID(multihash);
              _context.next = 4;
              return dag.get(cid, options);

            case 4:
              result = _context.sent;

              if (!(cid.codec === 'raw')) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", []);

            case 7:
              if (!(cid.codec === 'dag-pb')) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", result.value.Links);

            case 9:
              if (!(cid.codec === 'dag-cbor')) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", findLinks(result));

            case 11:
              throw new Error("Cannot resolve links from codec ".concat(cid.codec));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function links(_x, _x2) {
      return _links.apply(this, arguments);
    }

    return links;
  }());
};